import React from 'react';
import {
  PickersDay as MuiPickersDay,
  pickersDayClasses,
  PickersDayProps as MuiPickersDayProps,
} from '@mui/x-date-pickers';
import { styled } from '@mui/material';

type PickersDayProps = MuiPickersDayProps<Date> & {
  dayIsBetween: boolean;
  isFirstDay: boolean;
  isLastDay: boolean;
  isEventDay?: boolean;
  selectedDayIsBetween?: boolean;
  selectedIsFirstDay?: boolean;
  selectedIsLastDay?: boolean;
  reply?: boolean;
};

export const PickersDay = styled(MuiPickersDay, {
  shouldForwardProp: prop =>
    prop !== 'dayIsBetween' && prop !== 'isFirstDay' && prop !== 'isLastDay',
})<PickersDayProps>(
  ({
    theme,
    dayIsBetween,
    isFirstDay,
    isLastDay,
    isEventDay,
    selectedDayIsBetween,
    selectedIsFirstDay,
    selectedIsLastDay,
    reply,
  }) => ({
    [`&.${pickersDayClasses.root}`]: {
      [`&.${pickersDayClasses.selected}`]: {
        backgroundColor: '#83AD51',
        color: theme.palette.text.primary,
        fontWeight: 400,
      },
      '&::after': !reply &&
        isEventDay && {
          content: '""',
          width: '7px',
          height: '7px',
          borderRadius: '50%',
          border: '0.5px solid white',
          background: theme.palette.grey[500],
          position: 'absolute',
          top: 4,
          right: 4,
        },
      // [`&:not(.${pickersDayClasses.selected})`]: {
      //   border: 'none',
      // },
    },
    '&:focus': {
      border: reply ? `1px solid rgb(123, 81, 173,1)` : 'inherit',
      backgroundColor: reply ? 'rgb(123, 81, 173,0.2)' : '#83AD51',
      [`&.${pickersDayClasses.selected}`]: {
        willChange: 'background-color',
        border: `1px solid rgb(123, 81, 173,1)`,
        backgroundColor: reply ? 'rgb(123, 81, 173,0.2)' : '#83AD51',
      },
    },
    // ...(isEventDay && {
    //   // backgroundColor: theme.palette.divider,
    //   border: `1px dashed ${theme.palette.primary.main}`,
    // }),

    ...(reply &&
      (isFirstDay || isLastDay || dayIsBetween) && {
        border: `1px solid ${theme.palette.secondary.main}`,
      }),

    ...(dayIsBetween &&
      !reply && {
        backgroundColor: '#E3F7C9',
      }),

    ...(isFirstDay &&
      !reply && {
        backgroundColor: '#83AD51',
      }),

    ...(isLastDay &&
      !reply && {
        backgroundColor: '#83AD51',
      }),

    // ...(isEventDay &&
    //   (dayIsBetween || isFirstDay || isLastDay) && {
    //     // backgroundColor: theme.palette.divider,
    //     border: `1px dashed ${theme.palette.primary.main}`,
    //   }),

    ...((selectedIsFirstDay || selectedIsLastDay || selectedDayIsBetween) && {
      border: `1px solid rgb(123, 81, 173,1)`,
      backgroundColor: `rgb(123, 81, 173,0.2)`,
      // color: 'white',
      // fontWeight: 'bold',
    }),
  })
) as React.ComponentType<PickersDayProps>;
